@if (savedInstallationReportsResponse$ | async; as savedInstallationReports) {
  @if (savedInstallationReports.isLoading || isLoading) {
    <ipo-loading-spinner></ipo-loading-spinner>
  } @else {
    @if (savedInstallationReports.data) {
      <app-installation-report-table
        [ifs]="ifs"
        [installationReports]="installationReports"
        [filterText]="filterText"
        [filterFields]="filterFields"
        [isLoading]="isLoading"
        [savedInstallationReportsForProject]="savedInstallationReports.data"
        [currentDomainColumns]="columns()"
        (rowClicked)="openInstallationReportModal($event)"
      ></app-installation-report-table>
    }
  }
}
